import Vue from 'vue'
import Router from 'vue-router'

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/home/home')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/login')
    },
    {
      path: '/scienceResearch',
      name: 'scienceResearch',
      component: () => import('@/views/science/scienceResearch')
    },{
      path: '/partner',
      name: 'partner',
      component: () => import('@/views/partner/partner')
    },{
      path:'/clinicalService',
      name: 'clinicalService',
      component: () => import('@/views/clinical/clinicalService')
    },{
      path:'/newsContent',
      name: 'newsContent',
      component: () => import('@/views/news/newsContent')
    },{
      path:'/edu',
      name: 'edu',
      component: () => import('@/views/edu/edu')
    },{
      path:'/newsList',
      name: 'newsList',
      component: () => import('@/views/newsList/newsList')
    },{
      path:'/emhub',
      name: 'emhub',
      component: () => import('@/views/emhub/emhub')
    },{
      path:'/support',
      name: 'support',
      component: () => import('@/views/support/support')
    },{
      path:'/register',
      name: 'register',
      component: () => import('@/views/register/register')
    },{
      path:'/findPassword',
      name: 'findPassword',
      component: () => import('@/views/findPassword/findPassword')
    },{
      path:'/resetPassword',
      name: 'resetPassword',
      component: () => import('@/views/reset/resetPassword')
    },{
      path:'/resetSuccess',
      name: 'resetSuccess',
      component: () => import('@/views/reset/components/resetSuccess')
    },{
      path:'/auth',
      name: 'auth',
      component: () => import('@/views/auth/auth')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
